export const isString = wcardinal.ui.isString;